import styled from "@emotion/styled";

export const BarcodeWrapper = styled.div`
  border-radius: 6px;
  background: #f8faf9;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  position: relative;
  z-index: 10;
`;

export const TopTextContainer = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 4px;
  align-self: stretch;
  background: #f8faf9;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`;

export const BottomTextContainer = styled.div`
  display: flex;
  padding: 8px 16px 12px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: 8px;
  align-self: stretch;
  background: #f8faf9;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
`;

export const LegalTextContainer = styled.div`
  padding: 0 16px 12px 16px;
  background: #f8faf9;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  p {
    margin: 0;
    color: #2f383c;
    text-align: center;
    font-size: 12px;
    line-height: 1.5;
  }
  a {
    color: #0e893c;
    text-decoration: underline;
  }
`;

export const BarcodeContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 160px;
`;

export const BarcodeImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  img {
    height: 80px;
    width: 100%;
  }
`;

export const BarcodeText = styled.div`
  font-family: "RobotoMono", monospace;
  font-size: 1rem;
  letter-spacing: 0.1em;
  color: #2f383c;
  text-align: center;
`;

export const SuccessTopContainer = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  justify-content: center;
  background: #f8faf9;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`;

export const HelpIcon = styled.img`
  cursor: pointer;
  width: 24px;
  height: 24px;
  margin-left: 8px;
`;

export const QuotaContainer = styled.div`
  display: flex;
  padding: 14px 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 8px;
  padding: 16px;
  cursor: pointer;
  min-height: 160px;
`;

export const InfoText = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: #2f383c;
  line-height: 1.5;
`;

export const BoldText = styled.strong`
  font-weight: 700;
`;

export const CenteredBoldText = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: #2f383c;
  line-height: 1.5;
  text-align: center;
  font-weight: 700;
`;

export const CenteredText = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: #2f383c;
  line-height: 1.5;
  text-align: center;
`;

export const LeftBoldText = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: #2f383c;
  line-height: 1.5;
  font-weight: 700;
`;

export const WarningIcon = styled.img`
  width: 64px;
  height: 64px;
`;

export const OutlineWarningIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const GreyedOutContainer = styled.div`
  background-color: #f8faf9;
  color: #a0a0a0;
`;
